import {IController, IScope} from "angular";
import * as angular from "angular";
import {PlanningViewSettingsDraftModel, PlanningViewSettingsJobsModel} from "../../models/planning-view-settings.model";
import {PanelService} from "../../../commons/angular/services/panel.service";
import {PlanningTemplateDefaultDraftService} from "../../services/planning-template-default-draft.service";
import {
  PlanningDefaultDraftDialogComponent
} from "../../angular/components/planning-default-draft-dialog/planning-default-draft-dialog.component";


export class PlanningDraftItemCtrl implements IController {
  project: any;
  draft: any;
  isSelected: boolean;
  isChecked: boolean;
  isLean: boolean;
  disableDelete: boolean;
  displayOnly: string;
  isDuplicateDraftDisabled: boolean;
  settings: any;
  isAllowSettingsConfiguration: boolean;
  onSelect: Function;
  onExpend: Function;
  onCheck: Function;
  onDelete: Function;
  onReOptimize: Function;
  onUpdatePush: Function;
  onDuplicate: Function;
  onSettingsChange: Function;

  private isInit: boolean;
  private _savedDefaultDraft: { id: string, name: string };

  /* @ngInject */
  constructor(private $drafts, private $scope: IScope,
              private panelService: PanelService,
              private planningTemplateDefaultDraftService: PlanningTemplateDefaultDraftService) {
  }

  $onInit() {
    // if (!this.displayOnly) {
    //   let draftRef: any = this.$drafts(this.draft.id);
    //   draftRef.$bindCtrlToId(this.$scope, this, 'draft', 'id', {projectId: this.draft.projectId})
    //   draftRef.$registerOnUpdateHandler(this, (updatedDraft) => {
    //     if (this.isInit) {
    //       this.isInit = false;
    //     } else {
    //       this.onUpdatePush({draft: updatedDraft})
    //     }
    //   })
    // }
  }

  onChangeSettings(draftSettings: PlanningViewSettingsDraftModel) {
    const settingsCopy = angular.copy(this.settings);
    settingsCopy.draft = draftSettings;
    this.onSettingsChange({settings: settingsCopy});
  }

  onSaveAsDefaultDraft(event) {
    const existingId = this._savedDefaultDraft?.id || this.draft?.draftTemplateId;

    if (!!existingId) {
      this.planningTemplateDefaultDraftService.getDefaultDraftTemplates([existingId])
        .then((draftTemplates: any) => {
          const draftTemplate = !!draftTemplates && draftTemplates.length ? draftTemplates[0] : undefined;
          if (!!draftTemplate?.id) {
            this._savedDefaultDraft = {id: draftTemplate.id, name: draftTemplate.name};
            this._openDefaultDraftDialog(event, draftTemplate.id, draftTemplate.name || this.draft?.name);
            return;
          }
          this._openDefaultDraftDialog(event, undefined, this.draft?.name);
        })
        .catch(() => {
          this._openDefaultDraftDialog(event, undefined, this.draft?.name);
        });
      return;
    }

    this._openDefaultDraftDialog(event, undefined, this.draft?.name);
  }

  private _openDefaultDraftDialog(event, defaultDraftId: string, defaultDraftName: string) {
    const panel = this.panelService.open(PlanningDefaultDraftDialogComponent, event, {
      defaultDraftId: defaultDraftId,
      defaultDraftName: defaultDraftName
    }, {
      position: {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'top',
      },
      height: 250
    });

    if (!panel) {
      return;
    }

    panel.afterClose$.subscribe(data => {
      if (!data) {
        return;
      }
      if (!!data.isUpdate && !!defaultDraftId) {
        const updatePayload: any = {
          id: defaultDraftId,
          draftId: this.draft.id,
          name: data.defaultDraftName
        };
        this.planningTemplateDefaultDraftService.updateDefaultDraftTemplate(updatePayload)
          .then((response: any) => {
            const id = response?.id || defaultDraftId;
            this._savedDefaultDraft = {id: id, name: data.defaultDraftName};
          });
        return;
      }
      const createPayload: any = {
        draftId: this.draft.id,
        name: data.defaultDraftName
      };
      this.planningTemplateDefaultDraftService.createDefaultDraftTemplate(createPayload)
        .then((response: any) => {
          if (!!response?.id) {
            this._savedDefaultDraft = {id: response.id, name: data.defaultDraftName};
          }
        });
    });
  }
}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftItem', {
    bindings: {
      project: '<?',
      draft: '<',
      isSelected: '<',
      isChecked: '<',
      disableDelete: '<',
      isLean: '<',
      isDuplicateDraftDisabled: '<',
      isAllowSettingsConfiguration: '<',
      settings: '<',
      displayOnly: '@?',
      onSelect: '&',
      onExpend: '&',
      onCheck: '&',
      onDelete: '&',
      onReOptimize: '&',
      onUpdatePush: '&',
      onDuplicate: '&',
      onSettingsChange: '&'
    },
    template: require('./planning-draft-item.html').default,
    controller: PlanningDraftItemCtrl
  });
